/**
 * Returns the reader index with the active given slot type
 * @param readers
 * @param slotType
 * @return {*}
 */
import { readerSlotTypes } from '../../constants';

export const slotTypeInsertedReader = (readers, slotType) => readers && readers.findIndex(
  reader => (
    reader.i_slotType === slotType
    || (slotType === readerSlotTypes.VITALE && reader.s_name.toLowerCase() === 'vitale')
    || (slotType === readerSlotTypes.CPS && reader.s_name.toLowerCase().indexOf('pss reader on') !== -1)
  ),
);
export const getActiveReadersCount = readers => readers && readers.filter(r => r.s_accessMode !== 'GALSS/PCSC').length;
